import {KTIcon} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {UsersListFilter} from './UsersListFilter'
import { SendFriendAll_Start, SendFriendAll_Stop, Send_Friends, Send_Status } from '../../core/_requests'
import { AuthModel, getAuth } from '../../../../../auth';

let interval: NodeJS.Timer;

const IntervalFindFriend_End = () => {
  clearInterval(interval);

  SendFriendAll_Stop()
  .then((result) => {

    const lsValue: AuthModel | undefined  = getAuth();
    const lsValueAsString: string | undefined = lsValue ? JSON.stringify(lsValue) : undefined;    

    let rst = Send_Friends(lsValueAsString);
  });
}


const UsersListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  

  


  const openAddUserModal = () => {
    //IntervalFindFriend_Start();
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <UsersListFilter />

      {/* begin::Export */}
      {/* <button type='button' className='btn btn-light-primary me-3'>
        <KTIcon iconName='exit-up' className='fs-2' />
        Export
      </button> */}
      {/* end::Export */}

      {/* begin::Add user */}
      <button type='button' className='btn btn-primary' onClick={openAddUserModal}>
        <KTIcon iconName='plus' className='fs-2' />
        카카오톡 전체명단 불러오기
      </button>
      {/* end::Add user */}
    </div>
  )
}

export {UsersListToolbar, IntervalFindFriend_End}
